import styled from 'styled-components';

const StyledBtn = styled.button`
  background: #fff;
  padding: 5px 0;
  border: 1px solid var(--darkGrey);
  color: var(--darkGrey);
  font-size: 0.7rem;
  font-weight: 600;
  width: ${(props) => props.width};
  text-transform: uppercase;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  cursor: pointer;
  &:hover {
    background: var(--yellow);
    border: 1px solid var(--yellow);
    color: #fff;
  }
`;

const RoundedBtn = ({ children, clickEvent, width = '65px' }) => (
  <StyledBtn width={width} onClick={() => clickEvent()}>
    {children}
  </StyledBtn>
);

export default RoundedBtn;
